<template>
  <div class="wf-notifications" aria-live="polite" aria-atomic="true">
    <div 
      class="toast show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      v-for="notification in notifications"
      :key="notification.id"
    >
      <div class="toast-header">
        <strong>{{ notification.title }}</strong>
        <button
          type="button"
          class="toast-close close"
          data-dismiss="toast"
          aria-label="Close"
          @click="removeNotification(notification.id)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        {{ notification.description }}
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      notifications: 'notifications/notifications'
    })
  },
  methods: {
    ...mapActions({
      removeNotification: 'notifications/remove'
    })
  }
}
</script>